import Cookies from 'js-cookie'
import api from "../../api";

export const ioMixin = {
  computed: {
    accountToken () {
      let _t = Cookies.get('_t')
      if (_t) {
        let tokenPayload = _t && JSON.parse(window.atob(_t.split('.')[1]))
        return tokenPayload.User
      } else {
        return {}
      }
    }
  },
  methods: {
    reportedData(payload) {
      try {
        api.io.reportedData({
          cv_account_token: this.accountToken.c_t,
          hr_account_token: this.accountToken.h_t,
          ...payload
        }).then(() => {}).catch(e => console.log(e))
      } catch (e) {
        console.log(e)
      }
    }
  }
}
